export default function TopImage(props: { image: string, alt: string }) {
    return (
        <>
            <div style={{ textAlign: "center", backgroundColor: "black", borderBottomRightRadius: "2.5rem", borderBottomLeftRadius: "2.5rem", boxShadow: "rgba(0, 0, 0, 0.35) 0px 3px 10px 0px" }}>
                <img src={props.image} alt={props.alt} style={{ maxHeight: "50vh", maxWidth: "90vw" }} />
            </div>
        </>
    )
}